import { useSyncExternalStore } from 'react';

export type PreferenciaTema = 'claro' | 'escuro' | 'sistema';
export type Tema = 'claro' | 'escuro';

const CHAVE = 'fiscoai:tema';
const ouvintes = new Set<() => void>();

function lerPreferencia(): PreferenciaTema {
  try {
    const valor = globalThis.localStorage.getItem(CHAVE);
    return valor === 'claro' || valor === 'escuro' ? valor : 'sistema';
  } catch {
    return 'sistema';
  }
}

function sistemaEscuro(): boolean {
  return globalThis.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function resolverTema(preferencia: PreferenciaTema): Tema {
  if (preferencia === 'sistema') return sistemaEscuro() ? 'escuro' : 'claro';
  return preferencia;
}

let preferencia = lerPreferencia();

/** Aplica no <html data-tema> — é o que o theme.css lê. */
export function aplicarTema(): void {
  document.documentElement.dataset['tema'] = resolverTema(preferencia);
}

export function definirTema(nova: PreferenciaTema): void {
  preferencia = nova;
  try {
    if (nova === 'sistema') globalThis.localStorage.removeItem(CHAVE);
    else globalThis.localStorage.setItem(CHAVE, nova);
  } catch {
    // sem storage: vale até recarregar
  }
  aplicarTema();
  for (const ouvinte of ouvintes) ouvinte();
}

function assinar(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => ouvintes.delete(ouvinte);
}

export function usePreferenciaTema(): PreferenciaTema {
  return useSyncExternalStore(
    assinar,
    () => preferencia,
    () => 'sistema' as const,
  );
}
